export default __webpack_public_path__ + "static/media/about3.cd031736.jpeg";